function HasClass( el, cls )
{
    var current = el.getAttribute( "class" );
    return ( ( current != undefined ) && ( current.indexOf( cls ) != -1 ) );
}

function AddClass( el, cls )
{
    if ( el )
    {
        var current = el.getAttribute( "class" );
        if ( ( current == undefined ) || ( current.indexOf( cls ) == -1 ) )
        {
            current += " " + cls;
            el.setAttribute( "class", current );
        }
    }
}
function RemoveClass( el, cls )
{
    if ( el )
    {
        var current = el.getAttribute( "class" );
        if ( current )
        {
            current = current.replace( cls, ' ' );
            el.setAttribute( "class", current );
        }
    }
}
function SearchParentsFor( start, cls, top )
{
    var result;

    var parent = start.parentNode;
    if ( ( parent ) && (  parent.getAttribute ) )
    {
        var pcls = parent.getAttribute( "class" );
        if ( pcls )
        {
            var pclsArray = pcls.split( " " );
            for ( var i = 0; i < pclsArray.length; i++ )
            {
                if ( pclsArray[ i ] == cls )
                {
                    result = parent;
                    break;
                }
            }
        }

        if ( ( !result ) && ( ( !top ) || ( parent != top ) ) )
        {
            result = SearchParentsFor( parent, cls, top );
        }
    }

    return ( result );
}

function productQty( element )
{
    var parent      = SearchParentsFor( element, "lightning_qty_container" );
    var input       = parent.querySelector( "input" );
    var row         = SearchParentsFor( element, "cart__row" );
    console.log( "here again" );
    var lineItem    = row.dataset.cartItemIndex;
    var itemKey     = row.dataset.cartItemKey;
    var variant     = itemKey.split( ":" )[ 0 ];
    var price       = row.dataset.cartItemPrice;

    if( element.dataset.type == "add" )
    {
        input.value = Number( input.value ) + 1;
    }
    else
    {
        if( input.value > 0 )
        {
            input.value = input.value - 1;
        }
    }
    if( input.value == 0 )
    {
        removeProduct( lineItem );
    }
    else
    {
        UpdateProductQty( variant, lineItem, input.value, price, row, element.dataset.type );
    }
}

function UpdateProductQty( variant, lineItem, qty, price, row, direction )
{
    var xhr     = new XMLHttpRequest( );
    xhr.onreadystatechange = function( )
    {
        if ( xhr.readyState == 4 )
        {
            if ( xhr.status == 200 )
            {
                // AddNewVariant( qty, newVariant );
                // console.log( "updated qty successful" + JSON.stringify( xhr ) );
                // updateItemTotal( row, price, qty, direction );
                RebuildCart();
            }
            else
            {
                console.log( "updating qty failed" + xhr.responseText );
            }
        }
    };

    xhr.open( "POST", "/cart/change.js", true );
    xhr.setRequestHeader( "Content-Type", "application/json" );
    xhr.send( JSON.stringify( { "id" : variant, "quantity" : qty } ) );
}

function updateItemTotal( row, price, qty, direction )
{
    var itemTotalContainer          = row.querySelector( ".cart_item_total" );
    var currencySymbol              = row.dataset.cartCurrency;
    var newItemTotal                = ( ( Number( price ) * Number( qty ) ) / 100 );
    itemTotalContainer.innerHTML    = currencySymbol + newItemTotal.toFixed( 2 ); 
    itemTotalContainer.setAttribute( "data-cart-item-total", ( ( Number( price ) * Number( qty ) ) ) );
    updateCartTotal( );
}

function updateCartTotal(  )
{
    var rows                = document.querySelectorAll( ".item_cart_row" );
    var total               = 0;
    var cartTotalContainer  = document.querySelector( ".cart-subtotal__price" ); 
    var currencyISO         = cartTotalContainer.dataset.cartCurrencyIso;
    var currencySym         = cartTotalContainer.dataset.cartCurrency;

    for( var i = 0; i < rows.length; i++ )
    {
        var row                 = rows[ i ];
        var itemTotalContainer  = row.querySelector( ".cart_item_total" );
        var itemTotal           = Number( itemTotalContainer.dataset.cartItemTotal );
        total                   = total + itemTotal;
    }
    
    cartTotalContainer.innerHTML = currencySym + ( total / 100 ).toFixed( 2 ) + " " + currencyISO;

}

function updateProductVariant( select )
{
    var parent          = SearchParentsFor( select, "cart__row" );
    var qtyContainer    = parent.querySelector( ".product_qty_input" );
    var qty             = qtyContainer.value;
    var options         = select.options;
    var lineItem        = parent.dataset.cartItemIndex;
    var newVariant;

    for( var i = 0; i < options.length; i++ )
    {
        var option = options[ i ];
        option.removeAttribute( "selected", "selected" );
        if( select.selectedIndex == i )
        {
            option.setAttribute( "selected", "selected" );
            newVariant = option.value;
        }
    }

    removeProduct( lineItem, qty, newVariant, true )
}

function addProduct( qty, newVariant )
{
    var xhr     = new XMLHttpRequest( );
    xhr.onreadystatechange = function( )
    {
        if ( xhr.readyState == 4 )
        {
            if ( xhr.status == 200 )
            {
                window.location.reload( );
            }
            else
            {
                console.log( "add new variant faild" + xhr.responseText );
            }
        }
    };

    xhr.open( "POST", "/cart/add.js", true );
    xhr.setRequestHeader( "Content-Type", "application/json" );
    xhr.send( JSON.stringify( { "quantity" : qty, "id" : newVariant } ) );

}

function removeProduct( lineItem, qty, newVariant, add )
{
    var xhr     = new XMLHttpRequest( );
    xhr.onreadystatechange = function( )
    {
        if ( xhr.readyState == 4 )
        {
            if ( xhr.status == 200 )
            {
                if( add )
                {
                    addProduct( qty, newVariant );
                } 
                else
                {
                    window.location.reload( );
                }
            }
            else
            {
                console.log( "updating qty failed" + xhr.responseText );
            }
        }
    };

    xhr.open( "POST", "/cart/change.js", true );
    xhr.setRequestHeader( "Content-Type", "application/json" );
    xhr.send( JSON.stringify( { "line" : lineItem, "quantity" : 0 } ) );    
}

function GetCartMarkup( cb )
{
    var params =
    {
        "type"      : "GET",
        "url"       : "/cart",
        "dataType"  : "html",
        "success"   : function( markup )
        {
            cb( markup );
        }
    }
    jQuery.ajax( params );
}

function RebuildCart()
{
    GetCartMarkup( function( markup )
    {
        var markupContainer         = document.createElement( "div" );
        markupContainer.innerHTML   = markup;
        var section                 = document.querySelector( "#shopify-section-cart-template" );
        var replacementSection      = markupContainer.querySelector( "#shopify-section-cart-template" );
        
        document.querySelector( ".easylockdown-content" ).innerHTML = replacementSection.innerHTML;
    } );
}

$(document).ready(function(){
    $(document).on('keypress','.product_qty_input.cart__qty-input',function(event){
        var keycode = (event.keyCode ? event.keyCode : event.which);
        if(keycode == '13'){
            setTimeout(() => {
                window.location.href="/checkout";
            }, 1000);
            
        }
    });
  });